import { createAsyncThunk } from '@reduxjs/toolkit';
import moment from 'moment';
import { StatementService } from 'api';

import { StatementData } from 'models';

import { DATE_FORMATTER } from 'utils/constants';

export const getAccountSummary = createAsyncThunk('statement/getAccountSummary', async () => {
	const defaultParams: StatementData = {
		from: moment().subtract(1, 'month').format(DATE_FORMATTER),
		to: moment().format(DATE_FORMATTER),
		interval: 'day',
	};

	const getInterest = StatementService.getInterest(defaultParams);
	const getInvestment = StatementService.getInvestment(defaultParams);
	const getDepositWithdrawal = StatementService.getDepositWithdrawal(defaultParams);
	const getPrincipalRepayment = StatementService.getPrincipalRepayment(defaultParams);

	const allPromise = Promise.all([
		getInterest,
		getInvestment,
		getDepositWithdrawal,
		getPrincipalRepayment,
	]);

	const [income, investment, depositWithdrawal, principalRepayment] = await allPromise;

	return { income, investment, depositWithdrawal, principalRepayment };
});
